import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

/**
 * @todo Implement browser locale
 */
class ComputedNumberField extends React.Component {
    render() {
        const { elStyle, record, source } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        const value = record[source] || 0;
        const locale = this.context.config.language.system;

        const formattedNumber = new Intl.NumberFormat(locale).format(value);

        return <span style={ elStyle }>{ formattedNumber }</span>;
    }
}

ComputedNumberField.contextTypes = {
    config: PropTypes.object,
};

ComputedNumberField.propTypes = {
    elStyle: PropTypes.object,
    record: PropTypes.object,
    source: PropTypes.string,
};

export default ComputedNumberField;



// WEBPACK FOOTER //
// ./src/components/field/ComputedNumberField.js